import { Action } from '@ngrx/store';

export enum DbActionTypes {
  Dbname_Request = '[Dbname] DbName Request',
  Dbname_Success = '[Dbname] DbName Success',
  Dbname_Failure = '[Dbname] DbName Failure'
}

export class LoadDbs implements Action {
  readonly type = DbActionTypes.Dbname_Request;
}

export class LoadDbSuccess implements Action {
  readonly type = DbActionTypes.Dbname_Success;
  constructor(public payload: { dbs: [] }) {}
}

export class LoadDbFailure implements Action {
  readonly type = DbActionTypes.Dbname_Failure;
  constructor(public payload: any) {}
}

export type All = LoadDbs | LoadDbSuccess | LoadDbFailure;
